/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Work_Section_TasksInputs */

const vi_station_work_section_tasks = /** @type {(inputs: Station_Work_Section_TasksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp đến hạn`)
};

/**

* @param {Station_Work_Section_TasksInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_work_section_tasks = /** @type {((inputs?: Station_Work_Section_TasksInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Work_Section_TasksInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_work_section_tasks(inputs)
});